import {Col, Row} from "react-bootstrap";
import elements from "../../styles/settings/elements.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {selectApp} from "../../storage/slicers/appSlice";
import {NavLink} from "react-router-dom";
import {paths} from "../../storage/paths";
import image from "../../images/image.png";
import classes from "../../styles/pages/homePage.module.scss";

export default function Services({ count }){

    const dispatch = useDispatch();
    const appState = useSelector(selectApp);

    let list;
    if (count) {
        const services = appState.services;
        list = [];

        for (let i = 0; i < count; i++) {
            list.push(
                <Col key={services[i].id}>
                    <NavLink to={`/services/${services[i].id}`} className={elements.navLink}>
                        <div className={elements.itemBlock}>
                            <img src={services[i].image} className={elements.itemImg} alt={services[i].title} />
                            <div className={elements.itemDescription}>
                                <p>{services[i].title}</p>
                                <p>{services[i].description}</p>
                                <p>{services[i].price}$</p>
                                <p className={elements.addButton}>ADD +</p>
                            </div>
                        </div>
                    </NavLink>
                </Col>
            );
        }
    } else {
        list = appState.services.map((service) => (
            <Col key={service.id}>
                <NavLink to={`/services/${service.id}`} className={elements.navLink}>
                    <div className={elements.itemBlock}>
                        <img src={service.image} className={elements.itemImg} alt={service.title} />
                        <div className={elements.itemDescription}>
                            <p>{service.title}</p>
                            <p>{service.description}</p>
                            <p>{service.price}$</p>
                            <p className={elements.addButton}>ADD +</p>
                        </div>
                    </div>
                </NavLink>
            </Col>
        ));
    }

    if(count){
        return(
            <Row>
                <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <h1 className={elements.blockTitle}>Services</h1>
                    <Row>
                        {list}
                    </Row>
                    <NavLink to={paths.services} className={elements.navLink}><button className={elements.moreBtn}>MORE</button></NavLink>
                </Col>

                <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    <img src={image} className={classes.verticalImg}/>
                </Col>
            </Row>
        );
    }
    else{
        return(
            <Row>
                {list}
            </Row>
        );
    }
}